import { useEffect, useState } from 'react';
import { FilterNameKey, TFilterTag, TFilterItem } from '@src/types/weddingHallFilter';

const useWeddingHallFilterSheet = (items: TFilterItem) => {
	const [filterItems, setFilterItems] = useState<TFilterItem>(items);
  const [filterTags, setFilterTags] = useState<TFilterTag[]>([]);
	const [prevFilterTags, setPrevFilterTags] = useState<TFilterTag[]>([]);
  const [currentFilterType, setCurrentFilterType] = useState<FilterNameKey | null>(null);
	return {
		filterItems,
		setFilterItems,
		filterTags,
		setFilterTags,
		prevFilterTags,
		setPrevFilterTags,
		currentFilterType,
		setCurrentFilterType
	}
};

export default useWeddingHallFilterSheet;